import type { Raw } from './chatRows'

export interface ListTab {
  id: string
  name: string
  total: number
}

export function listTotal(row: Raw): number {
  const n = Number(row.users_total ?? row.usersCount ?? row.users_count ?? row.membersCount ?? row.members_count ?? row.count ?? row.total)
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
}

export function toListTab(row: Raw): ListTab | null {
  const id = String(row.id ?? row.list_id ?? '').trim()
  return id ? { id, name: String(row.name || row.listName || row.title || `List ${id}`), total: listTotal(row) } : null
}

/** Page through an OnlyFans list endpoint (50 a page) up to `maxPages`, dropping repeats. */
export async function pageAll(
  gateway: <T>(path: string, body?: Record<string, unknown>) => Promise<T>,
  path: string,
  maxPages: number,
): Promise<ListTab[]> {
  const out: ListTab[] = []
  const seen = new Set<string>()
  let offset = 0
  for (let page = 0; page < maxPages; page += 1) {
    const data = await gateway<{ list?: Raw[]; hasMore?: boolean; nextOffset?: number }>(path, { offset, limit: 50 })
    const rows = Array.isArray(data?.list) ? data.list : Array.isArray(data) ? (data as Raw[]) : []
    let added = 0
    for (const row of rows) {
      const tab = toListTab(row)
      if (!tab || seen.has(tab.id)) continue
      seen.add(tab.id)
      out.push(tab)
      added += 1
    }
    if (!data?.hasMore || !added) break
    offset = data.nextOffset && data.nextOffset > offset ? data.nextOffset : offset + rows.length
  }
  return out
}
